import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import { CssBaseline } from "@mui/material";

ReactDOM.createRoot(document.getElementById("root") as ReactDOM.Container).render(
  <StrictMode>
    <CssBaseline />
    <App />
  </StrictMode>
);
